module.exports = __webpack_public_path__ + "img/guia-hot-sale.jpeg";